<template>
    <stf-select v-model="internalValue" class="elf__filter" @input="$emit('input', $event)">
        <div slot="label">Input address</div>
        <div slot="value">
            <div v-if="value">
                <span class="elf__legend">{{ legend }}:</span> <span
                    class="elf__selected-label"> {{value.label}} </span>
            </div>
        </div>
        <section class="options delivery_order__options">
            <stf-select-option
                    class="elf__option"
                    v-for="item of options" :key="item.id" :value="item"
                    :class="{'elf__option--selected': item.id === value.id}">
                <span class="elf__option-label">   {{ item.label }}</span>
            </stf-select-option>
        </section>

    </stf-select>
</template>

<script>
    import {StfSelect, StfSelectOption} from 'stf-vue-select'


    export default {
        name: "EdaListFilter",
        components: {
            StfSelect,
            StfSelectOption
        },
        data() {
            return {
                internalValue: this.value
            }
        },
        props: {
            value: {
                type: Object, default: function () {
                    return {
                        id: null,
                        label: "",
                    }
                }
            },
            legend: {type: String, default: ""},
            options: {type: Array, default: []}
        },
    }
</script>

<style>

    .elf__filter {
        font-size: 1.1em;
        margin: 0 0.5em;
    }

    .elf__legend {
        color: white;
        font-weight: 300;
        padding-right: 0.5em;
    }

    .elf__selected-label {
        color: white;
        font-weight: 600;
    }

    .stf-select {
        height: 3em;
        background-color: #000101;
        background-color: #0E1A10;
        border-radius: 2em;
    }

    .stf-select, .stf-select__container {
        position: relative;
        box-sizing: border-box
    }

    .stf-select__container {
        height: 100%;
        cursor: pointer;
    }

    .stf-select__inner-wrapper {
        height: 100%;
        background-color: #000101;
        background-color: #0E1A10;
        border-radius: 2em;
        transition: all 0.1s ease;
        padding: 0 2em;
    }

    .stf-select_opened .stf-select__inner-wrapper {
        border-radius: 2em 2em 0 0em;
    }

    .stf-select__value {
        display: none;
        font-weight: 700;
        line-height: 32px
    }

    .stf-select__placeholder, .stf-select__value {
        height: 100%;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        box-sizing: border-box
    }

    .stf-select__placeholder {
        width: 100%;
        line-height: 40px;
        color: #888aa3;
        padding-top: 1px
    }

    .stf-select__options {

        font-family: "Poppins", sans-serif;
        width: 100%;
        min-height: 0;
        position: absolute;
        top: 50px;
        background-color: #000101;
        background-color: #0E1A10;
        border-radius: 0 0 2px 2px;
        visibility: hidden;
        cursor: pointer;
        z-index: -10
    }

    .stf-select_sm {
        height: 3em;
    }

    .stf-select_sm .stf-select__placeholder {
        line-height: 3em;
    }

    .stf-select_sm .stf-select__value {
        line-height: 3em;
    }

    .stf-select-options {
        display: block;
        max-height: 200px;
        overflow-y: auto;
        overflow-x: hidden;
        transition: border-radius 0.3s ease;
        border-radius: 2em 2em 2em 2em;
    }

    .stf-select_opened .stf-select-options {
        border-radius: 0em 0em 2em 2em;
    }

    .stf-select-option {
        position: relative;
        font-size: .9rem;
        line-height: 1.2;
        color: #dde2dd;
        text-align: center;
        padding: 1em 1em;
        border-bottom: 1px solid rgba(53, 48, 53, 0.22);
        box-sizing: border-box;
        outline: none
    }

    .stf-select-option:last-child {
    }

    .stf-select-option_selected {
        font-weight: 700;
        color: #fafffa;
    }

    .stf-select-option_selected:after {
        content: "";
        display: inline-block;
        width: 20px;
        height: 20px;
        background: url(data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMTZweCIgaGVpZ2h0PSIxNnB4IiB2aWV3Qm94PSIwIDAgMTYgMTYiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8IS0tIEdlbmVyYXRvcjogc2tldGNodG9vbCA0MiAoMzY3ODEpIC0gaHR0cDovL3d3dy5ib2hlbWlhbmNvZGluZy5jb20vc2tldGNoIC0tPgogICAgPHRpdGxlPjEyNDM2ODBBLTg4MzMtNEM1Qi05NEQ3LTA0QjBDMTlFRDlBMjwvdGl0bGU+CiAgICA8ZGVzYz5DcmVhdGVkIHdpdGggc2tldGNodG9vbC48L2Rlc2M+CiAgICA8ZGVmcz48L2RlZnM+CiAgICA8ZyBpZD0iU3ltYm9scyIgc3Ryb2tlPSJub25lIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPGcgaWQ9Ikljb24tLy1PdGhlci0vLURvbmUtQ2FyZ28iPgogICAgICAgICAgICA8ZyBpZD0iSWNvbiI+CiAgICAgICAgICAgICAgICA8ZyBpZD0iYm91bmRzIj4KICAgICAgICAgICAgICAgICAgICA8cmVjdCB4PSIwIiB5PSIwIiB3aWR0aD0iMTYiIGhlaWdodD0iMTYiPjwvcmVjdD4KICAgICAgICAgICAgICAgIDwvZz4KICAgICAgICAgICAgICAgIDxwYXRoIGQ9Ik03LDkuNDMxOTQwMjggTDQuNzA3MTA2NzgsNy4xMzkwNDcwNiBDNC4zMTY1ODI0OSw2Ljc0ODUyMjc3IDMuNjgzNDE3NTEsNi43NDg1MjI3NyAzLjI5Mjg5MzIyLDcuMTM5MDQ3MDYgQzIuOTAyMzY4OTMsNy41Mjk1NzEzNiAyLjkwMjM2ODkzLDguMTYyNzM2MzQgMy4yOTI4OTMyMiw4LjU1MzI2MDYzIEw2LjI5Mjg5MzIyLDExLjU1MzI2MDYgQzYuNDg4MTU1MzYsMTEuNzQ4NTIyOCA2Ljc0NDA3NzY4LDExLjg0NjE1MzggNywxMS44NDYxNTM4IEM3LjI1NTkyMjMyLDExLjg0NjE1MzggNy41MTE4NDQ2NCwxMS43NDg1MjI4IDcuNzA3MTA2NzgsMTEuNTUzMjYwNiBMMTIuNzA3MTA2OCw2LjU1MzI2MDYzIEMxMy4wOTc2MzExLDYuMTYyNzM2MzQgMTMuMDk3NjMxMSw1LjUyOTU3MTM2IDEyLjcwNzEwNjgsNS4xMzkwNDcwNiBDMTIuMzE2NTgyNSw0Ljc0ODUyMjc3IDExLjY4MzQxNzUsNC43NDg1MjI3NyAxMS4yOTI4OTMyLDUuMTM5MDQ3MDYgTDcsOS40MzE5NDAyOCBaIiBpZD0iQ29tYmluZWQtU2hhcGUiIGZpbGw9IiM0N0E3RDciIGZpbGwtcnVsZT0ibm9uemVybyI+PC9wYXRoPgogICAgICAgICAgICA8L2c+CiAgICAgICAgPC9nPgogICAgPC9nPgo8L3N2Zz4=) 50% no-repeat;
        position: absolute;
        top: 50%;
        right: 4px;
        margin-top: -10px
    }

    .stf-select-option:focus, .stf-select-option:hover {
        background: rgba(135, 138, 163, .1)
    }

    .stf-select__search-input {
        display: block;
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        border-radius: 2px;
        z-index: -1
    }

    .stf-select__search-input input {
        visibility: hidden;
        background-color: #fff;
        border: none;
        border-radius: 2px;
        padding: 0 9px
    }

    .stf-select__search-input:focus {
        outline: none
    }

    .stf-select_has-value .stf-select__value {
        display: block
    }

    .stf-select_has-value .stf-select__placeholder, .stf-select_opened .stf-select__placeholder {
        display: none
    }

    .stf-select_opened .stf-select__options {
        border-top: 1px solid rgb(25, 35, 26);
        visibility: visible;
        z-index: 9
    }

    .stf-select_opened .stf-select__search-input {
        z-index: 1
    }

    .stf-select_opened .stf-select__search-input input {
        visibility: visible;
        border-radius: 2px 2px 0 0;
        height: 32px;
        font-size: 12px;
        padding: 0 8px;
        width: 100%
    }

    .stf-select_opened.stf-select_empty .stf-select__options {
        display: none
    }

    .stf-select_opened.stf-select_empty .stf-select__search-input input {
        border-radius: 2px
    }

</style>